module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN210_1773497076.3f4a0bb2.png";